import {helpers} from 'vuelidate/lib/validators'

export const validateIf = (prop, validator) => function (value, parentVm) {
  return helpers.ref (prop, this, parentVm) ? validator (value) : true
}
